import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseRegisterOrganizationVariables {
  email: string;
  phone: string;
}

export interface UseRegisterOrganizationData {
  id: number;
}

export interface UseRegisterOrganizationErrorData {}

export function useRegisterOrganization() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseRegisterOrganizationData,
    AxiosError<UseRegisterOrganizationErrorData>,
    UseRegisterOrganizationVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .post<UseRegisterOrganizationData>(
          '/posht/ashena/requested-organization/',
          data,
        )
        .then(({ data }) => data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), {
          variant: 'success',
        });
      },
    },
  );
}
